import React, { useEffect, useState } from 'react';
import styles from "../MetaField.module.scss";
import { CustomDropdown } from 'components/shared/customDropdown';
import { TextField } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from 'redux/slices/triggerSlice';
import { setPublish } from 'redux/slices/globalSlice';

const options = [
    { label: "greater than or equal", value: "greater than or equal" },
    { label: "less than or equal", value: "less than or equal" },
    { label: "is between", value: "is between" },
    { label: "is not between", value: "is not between" }
];

const DistanceLocation = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Distance from Location (mi)", options: "greater than or equal", value: [""] });

    const dispatch = useDispatch();

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                if (value === "is between" || value === "is not between") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: [localOptions?.distance1, localOptions?.distance2], // Store distances in value array
                        distance1: "",
                        distance2: "",
                    };
                } else {
                    updatedOptions = {
                        ...updatedOptions,
                        value: [], // Ensure value is an empty array
                        distance1: "",
                        distance2: "",
                    };
                }
            } else if (name === "distance1" || name === "distance2") {
                updatedOptions = {
                    ...updatedOptions,
                    value: [updatedOptions?.distance1, updatedOptions?.distance2], // Ensure value is always an array
                };
            }

            // Ensure that value is always an array, even if it's a single item
            if (name === "value" && !Array.isArray(updatedOptions?.value)) {
                updatedOptions.value = [updatedOptions?.value];
            }

            return updatedOptions;
        });
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);
    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            value: item?.value || prev?.value
        }));
    }, [item?.operator, item?.value]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={"Distance from Location (mi)"} disabled={true} />
                <CustomDropdown
                    options={options}
                    width='200px'
                    onChange={(e) => {
                        handleChange(e?.target?.name, e?.target.value);
                    }}
                    value={localOptions?.options}
                    name="options"
                />
                {
                    localOptions?.options === "is between" || localOptions?.options === "is not between" ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <TextField
                                name="distance1"
                                sx={{ borderRight: "none" }}
                                onChange={(e) => handleChange(e?.target?.name, e?.target.value)}
                                value={localOptions?.value?.[0]}
                            />
                            <span style={{ fontWeight: "700", fontSize: "15px" }}>And</span>
                            <TextField
                                name="distance2"
                                onChange={(e) => handleChange(e?.target?.name, e?.target.value)}
                                value={localOptions?.value?.[1]}
                            />
                        </div>
                    ) : (
                        <TextField
                            name="value"
                            onChange={(e) => handleChange(e?.target?.name, e?.target.value)}
                            value={localOptions?.value?.[0]}
                        />
                    )
                }
            </div>

            <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleDelete}>
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default DistanceLocation;
